export default "__VITE_ASSET__BLmWgAJr__"